import cancel_teleradiologyApi from "@custom/rtk-apis/teleradiologist/cancelStudy";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const cancelTeleradiologistSlice = createSlice({
  name: "cancelTeleradiologistSlice",
  initialState,
  reducers: {
    clearCancelTeleradiologist: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cancel_teleradiologyApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(cancel_teleradiologyApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(cancel_teleradiologyApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default cancelTeleradiologistSlice.reducer;
export const { clearCancelTeleradiologist } = cancelTeleradiologistSlice.actions;
